<!-- 

超宽屏定制页中心的地图

 -->
 <template>
  <div style="height: 650px; position: relative">
    <div
      v-if="$route.path === '/screen28896'"
      style="position: absolute; z-index: 9999; bottom: 5px; right: 5px"
    >
      <div style="color: #a3b3cf">产业辐射区域种植面积 10 万亩</div>
    </div>
    <div id="background">
      <app-map @loaded="mapLoaded" style="height: 100%" />
    </div>
    <div id="foreground" v-if="mapReady" style="height: 100%">
      <transition name="fade">
        <router-view />
      </transition>
    </div>
  </div>
</template>
<script>
import AppMap from './AppMap.vue'
export default {
  components: { AppMap },
  data() {
    return {
      /**
       * 地图是否加载完成
       */
      mapReady: false,
    }
  },
  methods: {
    mapLoaded() {
      console.log('Map加载完成')
      this.mapReady = true
    },
  },
}
</script>
<style scoped>
#background {
  position: absolute;
  z-index: 888;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
#foreground {
  pointer-events: none;
  position: absolute;
  z-index: 999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/screen28896/map-zone/index.vue